<template lang="pug">
  include /mixins
  +b.review-form.VALIDATION-OBSERVER(
    ref="validator",
    v-slot="{ valid }",
    tag="form",
  )
    ui-loader(v-if='isLoad')
    +b.g-row--align_center.--justify_between.--justify_center-xl
      cell(
        cols='12'
      )
        d-control-textarea.is-textarea(
          :input-label='labels.comment'
          :rules="'required|min:5'",
          rows='2'
          v-model='form.comment',
          name='comment',
          ref='comment'
          error-classes='error-label--top'
        )
      cell(
        cols='12'
        align='end'
      )
        +b.g-row--justify_end
          +b.g-cell.g-cols
            +b.tt-button--primary.--fixed.BUTTON.tt-space_mt--6(
              type='submit'
              :disabled='isLoad',
              @click.prevent='prepareData(valid)'
            )
              +e.title.P {{ _('Ответить ') }}
</template>

<script>

import {
  ReviewCreate,
} from '@api/review.service'

import {
  AnswerMessage,
} from '@utils/submit'

import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'

export default {
  name: 'ReviewSlimAdd',
  mixins: [FormMixin],
  props: {
    info: {},
    product_type: {
      type: String,
    },
    product_id: {
      type: String,
    },
    reply: {},
    id: {},
    reply_name: {},
    promise: {},
    inline: {},
  },
  data() {
    return {
      labels: {
        comment: this._('Ваш ответ'),
      },
      form: {
        comment: this.info.reply_name ? `${this.info.reply_name}, ` : '',
        name: this.info.user_name || '',
        phone: this.info.user_phone || '',
        email: this.info.user_email || '',
        rate: 5,
        element: {
          type: this.info.product_type,
          id: this.info.product_id,
        },
        parent: this.info.id,
        reply: this.info.reply,
        advantages: '',
        disadvantages: '',
        photos: [],
        videos: [],
      },
      non_field_errors: '',
      isLoad: false,
      currentRating: '',
    }
  },
  methods: {
    setKeys(list, key) {
      this.form[key] = list.map(el => el.id)
    },
    showCurrentRating(rating) {
      if (rating) {
        this.currentRating = this.rates[rating]
        return
      }
      this.currentRating = this.rates[this.form.rate]
    },
    async prepareData(valid) {
      this.$refs.validator.validate()
      if (!valid) return

      this.submit(valid, this.form)
    },
    send(data) {
      return ReviewCreate.execute({}, data)
        .then(({ data: res }) => {
          this.$emit('close')
          this.$emit('isOver')
          AnswerMessage(res, this)
          this.form.name = null
          this.form.phone = null
          this.form.comment = null
          if (this.promise) this.promise(true)
          this.$refs.validator.$el.reset()
          this.$refs.validator.reset()
        })
    },
    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)
      this.non_field_errors = parsed.non_field_errors
      this.$refs.validator.setErrors(parsed)
    },
  },

}
</script>
